import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { RingTracking } from './analytics';
import Ring from './Ring';
import useVenueRoute from 'hooks/useVenueUrl/useVenueRoute';

const App: React.FC = () => {
    const route = useVenueRoute('/*');
    return (
        <RingTracking>
            <Router>
                <Routes>
                    <Route path={route} element={<Ring />} />
                </Routes>
            </Router>
        </RingTracking>
    );
};

export default App;
